import React, { useState } from "react";
import { connect } from "react-redux";
import { createEducation } from "./actions";
import './Education.css';

const NewEducationForm = ({ educations = [], onCreatePressed }) => {

    const [university, setUniversity] = useState('');
    const [degree, setDegree] = useState('');
    const [gpa, setGpa] = useState('');
    const [start, setStartDate] = useState('');
    const [end, setEndDate] = useState('');
    const [presentUniversity, setPresentUniversity] = useState(false);
    const [endDateEnabled, setEndDateEnabled] = useState(true);
    const [location, setLocation] = useState('');

    //     const [educationData, setEducationData] = useState(
    //     {
    //     university: '',
    //     degree: '',
    //     gpa: '',
    //     start: '',
    //     end: '',
    //     presentUniversity: false,
    //     // endDateEnabled: true
    // });

    // const handleAddEducation = () => {
    //     setEducationData([
    //       ...educationData,
    //       {
    //         university: '',
    //         degree: '',
    //         gpa: '',
    //         start: '',
    //         end: '',
    //         presentUniversity: false,
    //       },
    //     ]);
    //   };

    //   const handleUpdateEducation = (index, updates) => {
    //     setEducationData(
    //       educationData.map((education, i) => {
    //         if (i === index) {
    //           return { ...education, ...updates };
    //         }
    //         return education;
    //       })
    //     );
    //   };

    const addEducation = () => {
        onCreatePressed({
            university,
            degree,
            gpa,
            start,
            end,
            presentUniversity,
            location
        });
        setUniversity('');
        setDegree('');
        setGpa('');
        setStartDate('');
        setEndDate('');
        setPresentUniversity(false);
        setEndDateEnabled(true);
    }

    const endDateHandler = e => {
        setEndDate(e.target.value);

        // check end date greater than today date
        const today = new Date();
        const end = new Date(e.target.value);
        if (end > today) {
            setPresentUniversity(true);
            setEndDateEnabled(false);
        } else {
            setPresentUniversity(false);
            setEndDateEnabled(true);
        }
    }

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div className="form-box-group mb-2" style={{ marginBottom: '10px' }}>
                <div>
                    <label>University / College and School Name</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="University/College and School Name"
                        value={university}
                        name="University"
                        onChange={e => setUniversity(e.target.value)}
                    />
                </div>
                <div>
                    <label>Degree</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Degree"
                        value={degree}
                        onChange={e => setDegree(e.target.value)}
                    />
                </div>
                <div>
                    <label>Grade / GPA</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="GPA"
                        value={gpa}
                        onChange={e => setGpa(e.target.value)}
                    />
                </div>
            </div>
            <div className="form-box-group mb-2">
                <div>
                    <label>Location</label>
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Location"
                        value={location}
                        onChange={e => setLocation(e.target.value)}
                    />
                </div>
                <div>
                    <label style={{display:'block'}}>Start Date</label>
                    <input
                        type="month"
                        value={start}
                        onChange={e => setStartDate(e.target.value)}
                        cleared={() => setStartDate('')}
                        style={{ width: '200px' }}
                    />
                </div>
                <div>
                    <label style={{ display: 'block' }}>End Date(or expected)</label>
                    <input
                        type="month"
                        placeholder="End Date"
                        value={end}
                        onChange={endDateHandler}
                        enabled={endDateEnabled}
                        cleared={() => setEndDate('')}
                        style={{ width: '200px' }}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={university === '' ||
                        degree === '' ||
                        gpa === '' ||
                        start === '' ||
                        (end === '' && !presentUniversity)
                    }
                    onClick={addEducation}
                >
                    Add
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    experiences: state.educations,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: education => dispatch(createEducation(education)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewEducationForm);
